import React from "react";
import { cn } from "@/lib/utils";

type Props = {
  /** Uppercase heading, e.g. "Danger zone". */
  title: React.ReactNode;
  /** Explanatory body copy. */
  children?: React.ReactNode;
  /** Action-row lead-in (a title + description beside the control). */
  actionTitle?: React.ReactNode;
  actionDescription?: React.ReactNode;
  /** The destructive control (a button), pushed to the right of the row. */
  action?: React.ReactNode;
  additionalActions?: React.ReactNode;
  className?: string;
};

/** Red-tinted destructive zone — heading + body + an action row (info on the
 *  left, the control on the right). Ported from the prototype `.danger-card`;
 *  the one shared home for "delete workspace / account"-style blocks. */
export function DangerCard({ title, children, actionTitle, actionDescription, action, additionalActions, className }: Props) {
  const hasRow = actionTitle != null || actionDescription != null || action != null;
  return (
    <section className={cn("vb-danger-card", className)}>
      <h3 className="vb-danger-card__h">{title}</h3>
      {children != null && <div className="vb-danger-card__body">{children}</div>}
      {hasRow && (
        <div className="vb-danger-card__row">
          {(actionTitle != null || actionDescription != null) && (
            <div className="vb-danger-card__info">
              {actionTitle != null && <div className="vb-danger-card__info-t">{actionTitle}</div>}
              {actionDescription != null && (
                <div className="vb-danger-card__info-d">{actionDescription}</div>
              )}
            </div>
          )}
          {action}
        </div>
      )}
      {additionalActions}
    </section>
  );
}

export default DangerCard;
